/** Listas de Ajustes (sectores y motivos): comparar sin mayúsculas ni acentos. */
const normalizar = (s: string) =>
  s
    .trim()
    .toLocaleLowerCase("es")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

/** ¿Ya está `valor` en la lista? (`salvo`: la posición que se está renombrando). */
export const enLista = (lista: string[], valor: string, salvo?: number) =>
  lista.some((x, i) => i !== salvo && normalizar(x) === normalizar(valor));

/** Añade al final, salvo que la lista acabe en «Otro»: entonces, justo antes. */
export const anadirALista = (lista: string[], valor: string) => {
  const ultimo = lista[lista.length - 1];
  return ultimo && normalizar(ultimo) === "otro"
    ? [...lista.slice(0, -1), valor, ultimo]
    : [...lista, valor];
};
